import { Modal } from "flowbite-react";
import { PaymentInfo } from "@/types/payment.type";
import { useEffect, useMemo, useState } from "react";
import { FormNegativation } from "./form/FormNegativation";
import { verifyPaymentsNegativation } from "@/common/services/renter-negativation.api";
import Loading from "@/common/components/ui/loading/Loading";

type Props = {
  open: boolean;
  onClose: () => void;
  data: PaymentInfo[];
  renterId: undefined | string
}

export default function ModalCreateNegativation({ open, onClose, data, renterId }: Props) {
  const [invalidPayments, setInvalidPayments] = useState<string[]>([]);
  const [isVerifyingPayments, setIsVerifyingPayments] = useState(false);

  useEffect(() => {
    async function verifyNegativationPayments(payments: PaymentInfo[]) {
      if (!payments || payments.length === 0) {
        return;
      }

      setIsVerifyingPayments(true);

      try {
        const result = await verifyPaymentsNegativation();
        if (result.ok) {
          setInvalidPayments(result.data);
        }
      } catch (error) {
        console.error('Erro ao verificar pagamentos:', error);
        setInvalidPayments([]);
      } finally {
        setIsVerifyingPayments(false);
      }
    }

    setInvalidPayments([]);
    verifyNegativationPayments(data);
  }, [renterId, data]);


  const validPaymentNegativation = useMemo(() => {

    if (isVerifyingPayments) {
      return [];
    }


    const statusFilteredPayments = data.filter(payment =>
      payment.status === 'PENDING' || payment.status === 'OVERDUE'
    );


    return statusFilteredPayments.filter(payment =>
      payment.externalPaymentId !== undefined &&
      !invalidPayments.includes(payment.externalPaymentId)
    );
  }, [data, invalidPayments, isVerifyingPayments]);

  return (
    <Modal
      className="dark:text-black"
      size="6xl"
      show={open}
      onClose={onClose}
    >
      <Modal.Header>
        <span className="text-black">Criar Negativação</span>
      </Modal.Header>
      <Modal.Body>
        {/* ✅ Mostrar loading enquanto verifica os pagamentos */}
        {isVerifyingPayments ? (
          <div className="flex flex-col items-center justify-center py-8">
            <Loading />
            <p className="mt-4 text-gray-600">Verificando pagamentos...</p>
          </div>
        ) : validPaymentNegativation.length > 0 ? (
          <FormNegativation paymentsValid={validPaymentNegativation} renterId={renterId} />
        ) : (
          <div className="flex flex-col items-center justify-center py-8">
            <p className="text-gray-600">Nenhum pagamento válido encontrado para negativação.</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}